// extracted by mini-css-extract-plugin
export default {"container":"VideoStats_container__jJWMs","row":"VideoStats_row__370RQ","title":"VideoStats_title__B++Pe","value":"VideoStats_value__8VEky"};